// extracted by mini-css-extract-plugin
export default {"root":"src_root__9uA8R"};